import React from 'react';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display text-2xl text-white mb-3">{title}</h2>
    <div className="text-slate-300 leading-relaxed text-sm space-y-3">{children}</div>
  </section>
);

const Terms = () => (
  <div data-testid="legal-terms-page" className="pt-28 pb-24 max-w-3xl mx-auto px-6 sm:px-12">
    <div className="text-xs uppercase tracking-[0.3em] text-fuchsia-300 mb-3">Legal</div>
    <h1 className="font-display text-4xl font-bold text-white tracking-tight mb-2">Terms of Service</h1>
    <p className="text-slate-500 text-xs mb-10">Last updated: February 13, 2026</p>

    <Section title="1. Acceptance">
      <p>By creating a Maarivil account or using the platform, you agree to these Terms. If you do not agree, do not use the service.</p>
    </Section>

    <Section title="2. Eligibility &amp; account">
      <ul className="list-disc pl-5 space-y-1">
        <li>You must be at least 16 years old (18 for paid bookings or premium subscriptions).</li>
        <li>One person, one account. Multi-artist agency accounts are governed by a separate agreement.</li>
        <li>You are responsible for all activity under your account; keep your password safe.</li>
      </ul>
    </Section>

    <Section title="3. Marketplace role">
      <p>Maarivil is a discovery and booking-inquiry platform. We are <strong>not a party</strong> to bookings between artists and clients. Contracts, performance, payments outside Stripe Checkout, and dispute resolution are between the artist and the client.</p>
    </Section>

    <Section title="4. Artist content &amp; representations">
      <ul className="list-disc pl-5 space-y-1">
        <li>You warrant that all content you upload (profile photos, gallery, video links, milestones, testimonials) is original or that you have the necessary rights.</li>
        <li>You must not misrepresent skills, experience, social-media follower counts, or past performances.</li>
        <li>We may remove content or suspend accounts that we reasonably believe violate these terms or applicable law.</li>
      </ul>
    </Section>

    <Section title="5. Payments &amp; premium plans">
      <ul className="list-disc pl-5 space-y-1">
        <li>Premium subscriptions (Basic ₹499, Professional ₹1,499, Elite ₹4,999 / month) and event ticket purchases are processed by Stripe.</li>
        <li>All prices are inclusive of applicable taxes unless stated.</li>
        <li>Subscriptions auto-renew unless cancelled before the renewal date.</li>
        <li>Refunds are governed by Section 7.</li>
      </ul>
    </Section>

    <Section title="6. Verification &amp; KYC">
      <p>Identity verification (KYC) is optional for browsing but required for premium tiers and high-value bookings. Approved verification may grant a verified badge but does not constitute Maarivil&apos;s endorsement of any artist&apos;s skill or character.</p>
    </Section>

    <Section title="7. Refunds &amp; cancellations">
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Premium subscriptions:</strong> pro-rata refund within 7 days of first purchase if no premium feature has been used.</li>
        <li><strong>Event tickets:</strong> refundable up to 48 hours before the event unless the event listing states otherwise.</li>
        <li><strong>Booking inquiries:</strong> Maarivil does not collect booking fees during Phase 1, so refunds do not apply between client and artist beyond their direct agreement.</li>
      </ul>
    </Section>

    <Section title="8. Prohibited conduct">
      <p>You will not: harass other users, scrape data, post unlawful content, impersonate others, exchange contact details to circumvent the platform (except where Premium permits direct social-media linking), or use the AI features for illegal purposes.</p>
    </Section>

    <Section title="9. Termination">
      <p>We may suspend or terminate accounts that breach these Terms, with notice where reasonable. You may close your account at any time from the account settings.</p>
    </Section>

    <Section title="10. Governing law">
      <p>These Terms are governed by the laws of India. Disputes will be subject to the exclusive jurisdiction of the courts of Bengaluru, Karnataka.</p>
    </Section>

    <Section title="11. Changes">
      <p>We may update these Terms; the updated version will be posted here with a new &quot;Last updated&quot; date. Continued use after the date constitutes acceptance.</p>
    </Section>
  </div>
);

export default Terms;
